export const PausingIcon = (): JSX.Element => (
   <svg width='38' height='38' viewBox='0 0 38 38' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='38' height='38' rx='19' fill='#DCECFF' />
      <path
         d='M9.40579 19C9.40579 18.4477 9.85351 18 10.4058 18C10.9581 18 11.4058 18.4477 11.4058 19C11.4058 19.5523 10.9581 20 10.4058 20C9.85351 20 9.40579 19.5523 9.40579 19Z'
         fill='#589AE9'
      />
      <path
         d='M13 19C13 18.4477 13.4477 18 14 18C14.5523 18 15 18.4477 15 19C15 19.5523 14.5523 20 14 20C13.4477 20 13 19.5523 13 19Z'
         fill='#589AE9'
      />
      <path
         d='M16.5942 19C16.5942 18.4477 17.0419 18 17.5942 18C18.1465 18 18.5942 18.4477 18.5942 19C18.5942 19.5523 18.1465 20 17.5942 20C17.0419 20 16.5942 19.5523 16.5942 19Z'
         fill='#589AE9'
      />
      <path
         d='M20.1884 19C20.1884 18.4477 20.6361 18 21.1884 18C21.7407 18 22.1884 18.4477 22.1884 19C22.1884 19.5523 21.7407 20 21.1884 20C20.6361 20 20.1884 19.5523 20.1884 19Z'
         fill='#589AE9'
      />
      <path
         d='M23.7826 19C23.7826 18.4477 24.2303 18 24.7826 18C25.3349 18 25.7826 18.4477 25.7826 19C25.7826 19.5523 25.3349 20 24.7826 20C24.2303 20 23.7826 19.5523 23.7826 19Z'
         fill='#589AE9'
      />
      <path
         d='M27.3768 19C27.3768 18.4477 27.8245 18 28.3768 18C28.9291 18 29.3768 18.4477 29.3768 19C29.3768 19.5523 28.9291 20 28.3768 20C27.8245 20 27.3768 19.5523 27.3768 19Z'
         fill='#589AE9'
      />
   </svg>
);
